module.exports = __webpack_public_path__ + "static/Corprate_CareersMB-Header_03-2314aab510cc343a5351a153794f36fa.jpg";